/**
 * Validates string for being within the given length boundaries
 * @returns string with the error or empty string
 */
const validateLength = (value: string, minLength?: number, maxLength?: number): string => {
  if (value.length === 0) {
    return 'This field is required';
  }

  if (minLength && value.length < minLength) {
    return `Must be at least ${minLength} characters long`;
  }

  if (maxLength && value.length > maxLength) {
    return `Should not exceed ${maxLength} characters`;
  }

  return '';
};

export { validateLength };
